import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { v4 as guid } from 'uuid';

import { UniversalCreateStore } from '../state/universal-create.store';

@Component({
  selector: 'nty-universal-create-button-text',
  imports: [CommonModule],
  providers: [UniversalCreateStore],
  template: `
    <span [id]="id" [textContent]="vm$ | async" class="capitalize"></span>
  `,
  styles: `
    .capitalize {
      text-transform: capitalize;
    }
  `,
})
export class UniversalCreateButtonTextComponent implements AfterViewInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly store = inject(UniversalCreateStore);

  readonly id = `nty-universal-create-button-text-${guid()}`;
  private readonly defaultText = 'Create';
  private readonly _vm$ = new BehaviorSubject(this.defaultText);
  readonly vm$ = this._vm$.asObservable();

  private subscriptions?: Subscription;

  ngAfterViewInit(): void {
    this.subscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  private subscribe() {
    this.unsubscribe();

    this.subscriptions ??= new Subscription();

    // NOTE: It took a while to determine that [textContent] was the correct binding and not [innerText].
    //       We may be able to remove this component altogether if we want to.
    this.subscriptions.add(
      this.store.createButtonText$.subscribe(text => {
        this._vm$.next(text ?? this.defaultText);
        this.cdr.detectChanges();
      })
    );
  }

  private unsubscribe() {
    this.subscriptions?.unsubscribe();
    this.subscriptions = undefined;
  }
}
